import type { GetDashboardActivities200ActivitiesItem } from './getDashboardActivities200ActivitiesItem';

export type GetDashboardActivities200 = {
  activities?: GetDashboardActivities200ActivitiesItem[];
  message?: string;
  success: boolean;
};
